const gradientGroups = [
  { label: '< -20', min: -Infinity, max: -20, mid: -22.5 },
  { label: '-20 to -10', min: -20, max: -10, mid: -15 },
  { label: '-10 to -5', min: -10, max: -5, mid: -7.5 },
  { label: '-5 to 5', min: -5, max: 5, mid: 0 },
  { label: '5 to 10', min: 5, max: 10, mid: 7.5 },
  { label: '10 to 20', min: 10, max: 20, mid: 15 },
  { label: '> 20', min: 20, max: Infinity, mid: 22.5 }
];

export default gradientGroups;

